import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router";
import { AuthContext } from "../../context/authContext";
import AuthServices from "../../services/authServices";
import FullScreenLoader from "../FullScreenLoader";
import { decodeToken, verifyToken } from "../../utils/jose";

const PersistLogin = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  const authenticate = async () => {
    try {
      const resp = AuthServices.handleAuthentication();

      if (resp?.data) {
        const responseData = resp.data.split("~");

        const jwtValue = await verifyToken(
          responseData[1],
          responseData[0]
        );

        auth.setRoleId(jwtValue?.user_role_id);
        auth.setName(jwtValue?.name);
        auth.setIsAuthenticated(true);
        auth.setMustChangePassword(!!resp?.must_change_password);
        auth.setUserId(jwtValue?.id);
        auth.setEmail(jwtValue?.email);
        auth.setPhone(jwtValue?.mobile_no);
      }
    } catch (error) {
      console.error("Authentication error:", error);
    } finally {
      setLoading(false);
    }
  };

  authenticate();
}, []);

  return (
    <>
      {loading ? (
        <FullScreenLoader show={loading} backdrop={false} color="#000000" />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default PersistLogin;
